'use client'

import { useAppRouter } from '@/shared/lib/router'

import { useLevelContext } from '../../contexts/LevelContext'
import { HUD } from '../HUD'
import { LevelRedoBlockedState } from '../LevelRedoBlockedState'
import { StepLivesOver } from '../StepLivesOver'
import { StepRenderer } from '../StepRenderer'
import { StepSummary } from '../StepSummary'
import { StepTimeOver } from '../StepTimeOver'

import { useFlow } from '@/shared/lib/steps-flow'
import { AuthLoadingScreen } from '@/shared/ui/AuthLoadingStates'
import { UnavailableState } from '@/shared/ui/UnavailableState'

function ReadyLevelPlayContent() {
  const { state } = useFlow()

  if (state.status === 'time_over') return <StepTimeOver />
  if (state.status === 'lives_over') return <StepLivesOver />
  if (state.status === 'completed') return <StepSummary />
  return (
    <HUD.Root>
      <StepRenderer />
    </HUD.Root>
  )
}

export function LevelPlayPage() {
  const router = useAppRouter()
  const { levelPlayState } = useLevelContext()

  const handleBack = () => {
    if (window.history.length > 1) {
      router.back()
      return
    }

    router.push('/jornadas')
  }

  if (levelPlayState.kind === 'loading') {
    return <AuthLoadingScreen message="Carregando nível..." />
  }

  if (levelPlayState.kind === 'level_redo_blocked') {
    return (
      <LevelRedoBlockedState
        title={levelPlayState.title}
        description={levelPlayState.description}
        onBack={handleBack}
      />
    )
  }

  if (levelPlayState.kind !== 'ready') {
    return (
      <UnavailableState
        title={levelPlayState.title}
        description={levelPlayState.description}
        onAction={handleBack}
      />
    )
  }

  return <ReadyLevelPlayContent />
}
